import type { SVGProps } from "react";

export function WarningMarkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9995 9.00019V13.0002M11.9995 16.0002H12.0095M10.3625 3.59119L2.2565 17.1252C2.08939 17.4146 2.00096 17.7427 2.00001 18.0768C1.99905 18.411 2.0856 18.7396 2.25104 19.0299C2.41649 19.3203 2.65506 19.5622 2.94304 19.7317C3.23101 19.9013 3.55835 19.9924 3.8925 19.9962H20.1065C20.4405 19.9923 20.7677 19.9011 21.0555 19.7317C21.3433 19.5622 21.5818 19.3204 21.7472 19.0302C21.9126 18.74 21.9992 18.4116 21.9984 18.0776C21.9976 17.7435 21.9094 17.4155 21.7425 17.1262L13.6365 3.59019C13.466 3.30869 13.2257 3.07593 12.9389 2.91439C12.6522 2.75284 12.3286 2.66797 11.9995 2.66797C11.6704 2.66797 11.3468 2.75284 11.06 2.91439C10.7733 3.07593 10.533 3.30869 10.3625 3.59019V3.59119Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function WarningMarkFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.999 2.66797C12.328 2.66797 12.6519 2.7527 12.9385 2.91406C13.2252 3.07558 13.4662 3.30842 13.6367 3.58984L21.7422 17.126C21.909 17.4152 21.9972 17.7433 21.9981 18.0771C21.9989 18.4112 21.9125 18.7401 21.7471 19.0303C21.5817 19.3203 21.3434 19.562 21.0557 19.7314C20.7678 19.9009 20.4405 19.9922 20.1065 19.9961H3.89259C3.55848 19.9923 3.23132 19.9009 2.94337 19.7314C2.65547 19.562 2.41642 19.3205 2.25098 19.0303C2.08559 18.74 1.99911 18.4112 2.00001 18.0771C2.00096 17.743 2.08974 17.4144 2.25684 17.125L10.3623 3.59082C10.5328 3.30947 10.773 3.07557 11.0596 2.91406C11.3462 2.7526 11.6701 2.66805 11.999 2.66797ZM12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17H12.0098C12.5618 16.9997 13.0098 16.5521 13.0098 16C13.0098 15.4479 12.5618 15.0003 12.0098 15H12ZM12 8C11.4477 8 11 8.44772 11 9V13C11 13.5523 11.4477 14 12 14C12.5521 13.9997 13 13.5521 13 13V9C13 8.44788 12.5521 8.00026 12 8Z"
        fill="currentColor"
      />
    </svg>
  );
}
